
import React from 'react';
import ModernLayout from '@/components/layouts/ModernLayout';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return <ModernLayout>{children}</ModernLayout>;
};

export default MainLayout;
